const ages =  [
  "2-5 Yrs",
  "5-8 Yrs",
  "8-12 Yrs",
]
export default ages;